{
  "pt": {
    "common": {
      "search": "Procurar",
      "selected": "Selecionado"
    }
  }
}
